<div class="section-heading">
  <ng-content select="[editor-heading]" />
  <button
    class="advanced-toggle"
    type="button"
    [attr.aria-pressed]="advanced()"
    (click)="advanced.set(!advanced())">
    <fa-duotone-icon [icon]="faSliders" />
    {{ (advanced() ? 'Presets' : 'Advanced') | translate }}
  </button>
</div>
@if (advanced()) {
  <p class="section-description">
    {{ 'Fine-tune both themes, or add your own logo and wallpaper.' | translate }}
  </p>
  <div class="advanced-editor"><andor-theme-tabs /></div>
} @else {
  <p class="section-description">
    {{ 'Each style includes a light and dark theme.' | translate }}
  </p>
  <div class="preset-grid" role="group" [attr.aria-label]="'Theme presets' | translate">
    @for (preset of tiles(); track preset.id) {
      <andor-theme-preset-tile
        [preset]="preset"
        [selected]="selectedPreset()?.id === preset.id"
        (picked)="applyPreset(preset)" />
    }
  </div>
}
<div class="default-appearance">
  <span aria-hidden="true">{{ 'Default appearance' | translate }}</span>
  <div class="appearance-options" role="group" [attr.aria-label]="'Default appearance' | translate">
    @for (mode of modes; track mode) {
      <button
        type="button"
        [class.is-active]="config().colorMode === mode"
        [attr.aria-pressed]="config().colorMode === mode"
        (click)="setDefaultMode(mode)">
        <fa-duotone-icon [icon]="mode === 'light' ? faSunBright : faMoonStars" />
        {{ (mode === 'light' ? 'Light Mode' : 'Dark Mode') | translate }}
      </button>
    }
  </div>
</div>
<p class="theme-status" aria-live="polite">
  @if (selectedPreset(); as preset) {
    <span class="status-dot" aria-hidden="true"></span>
    {{ preset.name | translate }} ·
    {{ (config().colorMode === 'light' ? 'Light Theme' : 'Dark Theme') | translate }}
  } @else {
    {{ 'Custom' | translate }} ·
    {{ 'Picking a preset replaces custom colors and wallpapers.' | translate }}
  }
</p>
